// Backup list/put/get/delete fetch wrappers (ADR 0016, Cluster 16 api half).
// These were previously inline fetches inside the backup modal UI functions;
// extracted here so the wire layer is quarantined in api/ per the layered split.

export async function apiListBackups(): Promise<any>{
  const res = await fetch('/api/v1/identity/backups', { credentials: 'include' });
  if(!res.ok) throw new Error('list ' + res.status);
  return res.json();
}

export async function apiPutBackup(env: any): Promise<Response>{
  const res = await fetch('/api/v1/identity/backups', {
    method: 'POST', credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(env),
  });
  return res;
}

export async function apiGetBackup(ref: string): Promise<any>{
  const res = await fetch(`/api/v1/identity/backups/${encodeURIComponent(ref)}`, { credentials: 'include' });
  if(!res.ok){ const e: any = new Error('fetch ' + res.status); e.status = res.status; throw e; }
  return res.json();
}

export async function apiDeleteBackup(ref: string): Promise<void>{
  const res = await fetch(`/api/v1/identity/backups/${encodeURIComponent(ref)}`, {
    method: 'DELETE', credentials: 'include',
  });
  if(!res.ok) throw new Error('delete ' + res.status);
}
